import angular from 'angular';
import maxBy from 'lodash/maxBy';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';
import flattenDeep from 'lodash/flattenDeep';
import forEach from 'lodash/forEach';

class FixedSashesService {
    constructor(config, windowDimensionsService, dividersService, mullionsService) {
        this.config = config;
        this.windowDimensionsService = windowDimensionsService;
        this.dividersService = dividersService;
        this.mullionsService = mullionsService;
        this.newSashes = [];
        this.sashes = [];
    }

    createNewFixSash() {
        const newSash = {
            id: this.getNewSashId(),
            muntins: cloneDeep(this.config.jsonConfig.muntins),
            nearDividers: cloneDeep(this.config.jsonConfig.nearDividers),
            filling: {
                id: 888
            },
            type: {
                id: this.config.sashTypes.F,
                handlePosition: null,
                type: 'F'
            },
            intSashes: [],
            intDividers: [],
            handleInner: {}
        };

        return newSash;
    }

    getNewSashes() {
        return this.newSashes;
    }

    getNewSashId() {
        const allSashes = flattenDeep([this.getSashes(), this.getNewSashes()]);
        const sashWithHighestId = maxBy(allSashes, el => el.id);
        return sashWithHighestId.id + 1;
    }

    getSashes() {
        return this.sashes;
    }

    pushNewSash(sash) {
        this.newSashes.push(sash);
    }

    resetNewSashes() {
        this.newSashes = [];
    }

    splitHorizontally() {
        const horizontalSplits = this.windowDimensionsService.getHorizontalDividersLength();
        const sashes = cloneDeep(this.getNewSashes());

        for (let j = 0; j < sashes.length; j++) {
            const tmpNewSashes = [(sashes[j])];
            for (let i = 0; i < horizontalSplits; i++) {
                const newDivider = this.dividersService.createNewDivider('horizontal');
                newDivider.id = this.dividersService.getNewDividerId();
                const newSash = this.createNewFixSash();

                newSash.nearDividers = Object.assign(
                    cloneDeep(tmpNewSashes[i]).nearDividers, { top: newDivider.id }
                );
                const sashAbove = find(this.getNewSashes(), el => el.id === tmpNewSashes[i].id);
                sashAbove.nearDividers.bottom = newDivider.id;

                tmpNewSashes.push(newSash);
                this.pushNewSash(newSash);
                this.dividersService.pushDivider(newDivider);
            }
        }
    }

    setNewSashes(sashes) {
        this.newSashes = sashes;
    }

    setSashes(sashes) {
        this.sashes = sashes;
    }

    splitSash(sash, sashes) {
        this.resetNewSashes();
        this.setSashes(sashes);
        this.pushNewSash(cloneDeep(sash));

        this.splitVertically(sash);
        this.splitHorizontally(sash);

        return this.getNewSashes();
    }

    splitVertically(sash) {
        const verticalSplits = this.windowDimensionsService.getVerticalDividersLength();
        const sashes = cloneDeep(this.getNewSashes());
        const max = verticalSplits * sashes.length;

        for (let i = 0; i < max; i++) {
            const newSash = this.createNewFixSash();
            const newDivider = this.dividersService.createNewDivider('vertical');
            newDivider.id = this.dividersService.getNewDividerId();

            newSash.nearDividers = Object.assign(sash.nearDividers, { left: newDivider.id });
            this.newSashes[i].nearDividers.right = newDivider.id;

            this.pushNewSash(cloneDeep(newSash));
            this.dividersService.pushDivider(cloneDeep(newDivider));
        }
    }

    updateGroupDimensions(fixedSashesGroup, sashWidth, sashHeight) {
        const initialX = fixedSashesGroup[0].x;
        const initialY = fixedSashesGroup[0].y;
        const width = sashWidth / (this.windowDimensionsService.verticalDividersLength + 1);
        const height = sashHeight / (this.windowDimensionsService.horizontalDividersLength + 1);
        let newIndex;

        forEach(fixedSashesGroup, (el, index) => {
            const splittedSash = el;
            let x;
            let y;

            if (index <= this.windowDimensionsService.verticalDividersLength) {
                x = index % this.windowDimensionsService.multiplierHor;
                y = Math.floor(index / this.windowDimensionsService.multiplierHor);
            } else {
                newIndex = index - (this.windowDimensionsService.verticalDividersLength + 1);
                y = (newIndex % (this.windowDimensionsService.horizontalDividersLength)) + 1;
                x = Math.floor(newIndex / (this.windowDimensionsService.horizontalDividersLength));
            }
            splittedSash.width = width;
            splittedSash.height = height;
            splittedSash.x = initialX + (x * width);
            splittedSash.y = initialY + (y * height);

            this.dividersService.updateAdjacentDividersDimensions(el);
        });
    }
}

FixedSashesService.$inject = [
    'config',
    'windowDimensionsService',
    'dividersService',
    'mullionsService'
];

export default angular.module('fixedSashesService', [])
    .service('fixedSashesService', FixedSashesService)
    .name;